import isEqual from 'lodash/isEqual';
import { ANALYTIC_HINTS_MESSAGE } from '../../../../components/hints/constants';
import { sendKinesisEvent } from '../../../analytics/kinesis/actions';
import { SET_HINTS } from './actionTypes';
export function setHints(value) {
    return {
        type: SET_HINTS,
        value
    };
}
function isSettingsTabChanged(state, objParams) {
    const { enabled, enabledSoundHints, presetHints } = state['wildix/features/hints'];
    const compareStoreObject = {
        enabled,
        enabledSoundHints,
        presetHints
    };
    return isEqual(compareStoreObject, objParams);
}
export function submitHintsTab(payload) {
    return (dispatch, getState) => {
        const { enabled, enabledSoundHints, presetHints } = payload;
        const compareObject = {
            enabled,
            enabledSoundHints,
            presetHints
        };
        const state = getState();
        // If settings didn't change dont ave data
        if (!presetHints || isSettingsTabChanged(state, compareObject)) {
            return;
        }
        const data = {
            enabled,
            enabledSoundHints,
            presetHints
        };
        dispatch(setHints(data));
        APP.wildix.storage.setHintsSettings(data);
        dispatch(sendKinesisEvent({
            ...data,
            message: ANALYTIC_HINTS_MESSAGE.hints,
            presetHints: APP.wildix.methods.translate(presetHints.nameKey)
        }));
    };
}
